import { titleize } from "underscore.string";

export default function prefixCss(property, value) {
  return ["Moz", "ms", "O", "Webkit", ""].reduce((memo, prefix) => {
    let localProperty = property;

    // If there is a prefix, then titleize the property.
    if (prefix.length) {
      localProperty = titleize(localProperty);
    }

    memo[prefix + localProperty] = value;
    return memo;
  }, {});
}
